import { CollectionStateProvider } from 'Context/CollectionStateContext';
import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
} from './Container';

export const TaxDiagnosticNoteHistory = ({ relationship }) => {
  return (
    <CollectionStateProvider
      args={{
        link: relationship.link('related'),
      }}
    >
      <Container />
    </CollectionStateProvider>
  );
};

TaxDiagnosticNoteHistory.propTypes = {
  relationship: PropTypes.object.isRequired,
};
